// Notificacao do proprio sistema operacional (fora da aba do navegador).
//
// Complementa o toast interno do NotificationsPopOver: quando o vendedor esta
// em OUTRA aba (ex.: no Sistema de Disparo), em outra janela ou com o
// navegador minimizado, o toast ate aparece na tela do CRM, mas ele nao esta
// olhando pra ela. A Notification do navegador surge por cima de tudo, como
// um aviso do Windows/macOS, e chama a atencao.
//
// LIMITE IMPORTANTE: isso so funciona enquanto a aba do CRM continua ABERTA
// (mesmo que em segundo plano/minimizada). Com a aba TOTALMENTE fechada, o
// navegador nao roda nosso codigo, e ai so daria com Web Push + service
// worker, que e bem mais complexo e fica pra outro momento.

export const suportaNotificacao = () =>
  typeof window !== "undefined" && "Notification" in window;

export const permissaoConcedida = () =>
  suportaNotificacao() && Notification.permission === "granted";

// Pede a permissao uma unica vez. O Chrome costuma aceitar no carregamento da
// pagina; Safari e algumas versoes exigem um gesto do usuario, por isso quem
// chama tambem dispara isto no primeiro clique da pagina.
export const pedirPermissaoNotificacao = async () => {
  if (!suportaNotificacao()) return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch (e) {
    // Navegadores antigos usam callback em vez de Promise; ignoramos e
    // seguimos com o valor atual da permissao.
    return Notification.permission;
  }
};

export const mostrarNotificacaoDesktop = ({
  titulo,
  corpo,
  icone = "/logo.png",
  tag,
  aoClicar,
  fixo = false,
} = {}) => {
  if (!permissaoConcedida()) return null;
  try {
    const n = new Notification(titulo || "Novo aviso", {
      body: corpo || "",
      icon: icone,
      // Mesma tag substitui o aviso anterior em vez de empilhar varios.
      tag,
      renotify: !!tag,
      // fixo: o aviso fica na tela ate a pessoa clicar (cliente transferido).
      requireInteraction: !!fixo,
    });

    n.onclick = () => {
      try {
        window.focus();
      } catch (e) {}
      if (typeof aoClicar === "function") aoClicar();
      n.close();
    };

    return n;
  } catch (e) {
    return null;
  }
};
